/* eslint-disable security/detect-unsafe-regex */
export default (x: number): string => {
  const isNegative = x < 0;
  const parts = Math.abs(x).toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedNumber = parts.join('.');
  return isNegative ? `-${formattedNumber}` : formattedNumber;
};
